import React, { Component } from 'react';
import PropTypes from 'prop-types';
import counterpart from 'counterpart';

import Autocomplete from 'Components/autocomplete/Autocomplete';
import HollowButton from 'Components/Button/HollowButton';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import TextInput from 'Components/forms/text-input/TextInput.jsx';
import Label from 'Components/forms/label/Label';

import InlineLoader from 'Components/loaders/InlineLoader';

import './OrgSelectorWidgetAccounts.scss';

class OrgSelectorWidgetAccounts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      searchOnly: props.labelText === 'MERCHANT',
      searchTerm:props.searchTerm,
    };

    this.attachBindings();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.forceClose) {
      this.setState({
        isOpen: false,
      });
    }
    if (this.state.searchOnly && (nextProps.dataList.length > 0 || nextProps.chainSelected)) {
      this.setState({ searchOnly: false });
    } else if (!this.state.searchOnly && nextProps.selectedItems.length === 0 && nextProps.dataList.length === 0 && this.props.labelText === 'MERCHANT') {
      this.setState({ searchOnly: true });
    }
  }
  
  attachBindings() {
    this.toggleAutocomplete = this.toggleAutocomplete.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  toggleAutocomplete() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  handleSelect(event) {
    if (this.props.forceCloseOnSelect || (this.props.forceCloseOnSelectAll && event === 'All')) {
      this.setState({ isOpen: false });
    }
    this.setState({ searchTerm: '' });
    this.props.handleSelect(event);
  }

  handleBlur(event) {
    const relatedTarget = event.relatedTarget ||
                          event.explicitOriginalTarget ||
                          document.activeElement; // IE11

    if (!this.widget.contains(relatedTarget)) {
      this.setState({
        isOpen: false,
      });
    }
  }

   // onChange for search field
   handleSearch = (searchTerm) => {
    if (this.props.enableLazyLoadSearch) {
      const value = searchTerm.target.value ? searchTerm.target.value : searchTerm.target.value;
      this.setState({searchTerm : value} , () => {
        return this.props.onLazyLoadSearch(this.state.searchTerm);
      });     
    } else {
      this.setState({ searchTerm });
    }
    return 0;
  }

  render() {
    const isDisabled = !this.props.enabled && !this.props.enableLazyLoadSearch;
    let cssName = this.props.isGlobalSelector ? (this.props.labelText === 'MERCHANT' ?
    'org-selector-widget width-selector-widget-MerchantWidth' :
    'org-selector-widget width-selector-widget-CorpWidth') : 'org-selector-widget';
    if (this.props.isLoading) {
      cssName = `${cssName} org-selector-widget-spinning`;
    } else if (this.props.needsInput) {
      cssName = `${cssName} field-danger`;
    }
    const searchTerm = (this.state.searchTerm) ? this.state.searchTerm.trim().replace(/^0/, '') : this.state.searchTerm;
    const labelText = this.props.labelText === 'MERCHANT' ? (counterpart('globalTranslate.globalSelectorFlag.merchantId')) : counterpart(`globalTranslate.forms.${this.props.labelText.toLowerCase()}`);
    const placeholder = this.props.enableLazyLoadSearch ? this.props.lazySearchPlaceholder : this.props.placeholder;
    const dataList = this.props.dataList.filter((i) => !searchTerm || i.mainLine.replace(/^0/, '').substr(0, searchTerm.length) === searchTerm);
     return (
      <div
      /* eslint-disable no-nested-ternary, no-plusplus */
        className={cssName}
        /* eslint-enable no-nested-ternary, no-plusplus */
        ref={(ref) => { (this.widget = ref); }}
        onBlur={this.handleBlur}
        tabIndex="-1"
        role="button"
      >
        <Label
          htmlFor={counterpart(`globalTranslate.forms.${this.props.labelText.toLowerCase()}`)}
        >
          <span className="heirarchyLabel">
            {labelText}
            {this.props.needsInput &&
              <InformationBubble
                id={labelText}
                error
                tooltipContent={`${labelText} is Required`}
              />
            }
            {this.props.isLoading &&
              <InlineLoader stroke={'#0a61ad'} />
            }
          </span>
        </Label>
        {!this.state.searchOnly &&
          <HollowButton
            id={this.props.labelText}
            action={this.toggleAutocomplete}
            disabled={this.props.isLoading || this.props.isLocked || isDisabled}
            extraClass={(this.props.needsInput) ? 'merchant-number-selector-drop-down red-border' : 'merchant-number-selector-drop-down'}
          >
            {this.props.isLoading ? 'Loading...' : this.props.selectedTerm}
          </HollowButton>
        }
        {this.state.searchOnly &&
          <TextInput
            type="text"
            onChange={this.handleSearch}
            placeholder={placeholder}
            min={10000}
            value={this.props.enteredMid}
            disable={this.props.isBaseLevelSelected}
          />
        }
        {!isDisabled && (this.state.isOpen || this.state.searchOnly) &&
          <Autocomplete
            dataList={(this.props.dataList.length > 0 || this.props.enableLazyLoadSearch) ? dataList : [{ id: 'not found', mainLine: counterpart('globalTranslate.caseSearch.noItemsFound') }]}
            selectedItems={this.props.selectedItems}
            handleSelect={this.handleSelect}
            onChange={this.handleSearch}
            placeholder={placeholder}
            searchTerm={this.state.searchTerm}
            extraClass={this.state.searchOnly ? 'search-only' : ''}
            visible={!this.state.searchOnly}
            canViewHierarchySelector={this.props.canViewHierarchySelector}
          />
        }
      </div>
    );
  }
}

OrgSelectorWidgetAccounts.propTypes = {
  dataList: PropTypes.array.isRequired,
  handleSelect: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  searchTerm: PropTypes.string,
  placeholder: PropTypes.string,
  selectedTerm: PropTypes.string,
  labelText: PropTypes.string,
  forceClose: PropTypes.bool,
  forceCloseOnSelect: PropTypes.bool,
  forceCloseOnSelectAll: PropTypes.bool,
  isGlobalSelector: PropTypes.bool,
  onOpened: PropTypes.func,
  isLoading: PropTypes.bool,
  selectedItems: PropTypes.array,
  isLocked: PropTypes.bool,
  enableLazyLoadSearch: PropTypes.bool,
  lazySearchPlaceholder: PropTypes.string,
  onLazyLoadSearch: PropTypes.func,
  enabled: PropTypes.bool.isRequired,
  needsInput: PropTypes.bool,
  chainSelected: PropTypes.bool,
  canViewHierarchySelector: PropTypes.bool,
};

OrgSelectorWidgetAccounts.defaultProps = {
  placeholder: '',
  searchTerm: '',
  selectedTerm: '',
  labelText: '',
  forceClose: false,
  forceCloseOnSelect: false,
  forceCloseOnSelectAll: false,
  isGlobalSelector: false,
  onChange: null,
  onOpened: () => {},
  isLoading: false,
  selectedItems: [],
  isLocked: false,
  enableLazyLoadSearch: false,
  lazySearchPlaceholder: '',
  onLazyLoadSearch: () => {},
  needsInput: false,
  chainSelected: false,
  canViewHierarchySelector: false,
};

export default OrgSelectorWidgetAccounts;
